/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShareNetworkIcon24Solid = forwardRef('ShareNetworkIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M20.5 6a3.75 3.75 0 0 1-6.187 2.85l-4.612 2.54a3.776 3.776 0 0 1 0 1.22l4.612 2.54a3.75 3.75 0 1 1-1.251 2.165L8.495 14.8a3.75 3.75 0 1 1 0-5.6l4.567-2.515A3.75 3.75 0 1 1 20.5 6Z" })));
});
